// const images = require('./images/*.jpg');

const gallery1 = new URL('../images/gallery/gallery-1.jpg', import.meta.url).href;
const gallery2 = new URL('../images/gallery/gallery-2.jpg', import.meta.url).href;
const gallery3 = new URL('../images/gallery/gallery-3.jpg', import.meta.url).href;
const gallery4 = new URL('../images/gallery/gallery-4.jpg', import.meta.url).href;
const gallery5 = new URL('../images/gallery/gallery-5.jpg', import.meta.url).href;
const gallery6 = new URL('../images/gallery/gallery-6.jpg', import.meta.url).href;
const gallery7 = new URL('../images/gallery/gallery-7.jpg', import.meta.url).href;
const gallery8 = new URL('../images/gallery/gallery-8.jpg', import.meta.url).href;
const gallery9 = new URL('../images/gallery/gallery-9.jpg', import.meta.url).href;
const gallery10 = new URL('../images/gallery/gallery-10.jpg', import.meta.url).href;
const gallery11 = new URL('../images/gallery/gallery-11.jpg', import.meta.url).href;
const gallery12 = new URL('../images/gallery/gallery-12.jpg', import.meta.url).href;

// Battery

function toggleSlideoverBattery() {
    document.getElementById('slideover-battery-container').classList.toggle('invisible');
    document.getElementById('slideover-battery-bg').classList.toggle('opacity-0');
    document.getElementById('slideover-battery-bg').classList.toggle('opacity-50');
    document.getElementById('slideover-battery').classList.toggle('translate-y-full');

    var element = document.getElementById("body");
    element.classList.toggle('noscroll');
}

document.addEventListener('DOMContentLoaded', function () {
    var toggleButton = document.querySelector('#batteryButton1');
    if (toggleButton) {
        toggleButton.addEventListener('click', toggleSlideoverBattery);
    }
});

document.addEventListener('DOMContentLoaded', function () {
    var toggleButton = document.querySelector('#batteryButton2');
    if (toggleButton) {
        toggleButton.addEventListener('click', toggleSlideoverBattery);
    }
});

document.addEventListener('DOMContentLoaded', function () {
    var toggleButton = document.querySelector('#batteryButton3');
    if (toggleButton) {
        toggleButton.addEventListener('click', toggleSlideoverBattery);
    }
});

document.addEventListener('DOMContentLoaded', function () {
    var toggleButton = document.querySelector('#slideover-battery-bg');
    if (toggleButton) {
        toggleButton.addEventListener('click', toggleSlideoverBattery);
    }
});

document.addEventListener('DOMContentLoaded', function () {
    var toggleButton = document.querySelector('#slideover-battery');
    if (toggleButton) {
        toggleButton.addEventListener('click', toggleSlideoverBattery);
    }
});

// Gallery

function toggleSlideoverGallery(e) {
    document.getElementById('slideover-gallery-container').classList.toggle('invisible');
    document.getElementById('slideover-gallery-bg').classList.toggle('opacity-0');
    document.getElementById('slideover-gallery-bg').classList.toggle('opacity-50');
    document.getElementById('slideover-gallery').classList.toggle('translate-y-full');

    var element = document.getElementById("body");
    element.classList.add('noscroll');

    var imageUrl = e.currentTarget.myParam;
    var altText = 'Description of the image';
    var imageElement = createImage(imageUrl, altText);

    var content = document.getElementById('gallery-content');
    content.innerHTML = "";
    content.appendChild(imageElement);
}

function closeSlideoverGallery(e) {
    document.getElementById('slideover-gallery-container').classList.toggle('invisible');
    document.getElementById('slideover-gallery-bg').classList.toggle('opacity-0');
    document.getElementById('slideover-gallery-bg').classList.toggle('opacity-50');
    document.getElementById('slideover-gallery').classList.toggle('translate-y-full');

    var element = document.getElementById("body");
    element.classList.remove('noscroll');

    // var content = document.getElementById('gallery-content');
    // content.innerHTML = "";
    
}

function createImage(src, altText) {

    var img = document.createElement('img'); // Create a new img element
    img.classList.add('gallery-lightbox-image');
    img.alt = altText; // Set the alt attribute of the img element

    img.addEventListener('load', function () {
        requestAnimationFrame(function () {
            img.classList.add('is-loaded');
        });
    }, { once: true });

    img.src = src; // Set the src attribute of the img element
    return img; // Return the created img element

}

document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-lightbox]').forEach(function (button) {
        button.addEventListener('click', function (e) {
            var image = e.currentTarget.querySelector('img');
            e.currentTarget.myParam = image.currentSrc || image.src;
            toggleSlideoverGallery(e);
        });
    });
});

document.addEventListener('DOMContentLoaded', function () {
    var galleryImages = [
        gallery1, gallery2, gallery3, gallery4, gallery5, gallery6,
        gallery7, gallery8, gallery9, gallery10, gallery11, gallery12
    ];

    galleryImages.forEach(function (imageUrl, index) {
        var galleryImage = document.querySelector('#gallery-image-' + (index + 1));

        if (!galleryImage) {
            return;
        }

        galleryImage.myParam = imageUrl;
        galleryImage.addEventListener('click', toggleSlideoverGallery, false);
    });
});


document.addEventListener('DOMContentLoaded', function () {
    var toggleButton = document.querySelector('#slideover-gallery-bg');
    if (toggleButton) {
        toggleButton.addEventListener('click', closeSlideoverGallery);
    }
});

document.addEventListener('DOMContentLoaded', function () {
    var toggleButton = document.querySelector('#slideover-gallery');
    if (toggleButton) {
        toggleButton.addEventListener('click', closeSlideoverGallery);
    }
});

// Scroll reveal

document.addEventListener('DOMContentLoaded', function () {
    var elements = document.querySelectorAll('[data-reveal]');

    if (!elements.length) {
        return;
    }

    document.documentElement.classList.add('reveal-ready');

    if (!('IntersectionObserver' in window)) {
        elements.forEach(function (element) {
            element.classList.add('is-visible');
        });
        return;
    }

    var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
            if (!entry.isIntersecting) {
                return;
            }

            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
        });
    }, {
        threshold: 0.15
    });

    elements.forEach(function (element) {
        observer.observe(element);
    });
});
